import React from 'react';
import Field from '../../Field';
import useNames from '../../../hooks/useNames';
import s from './transaction.module.css';
import { DateInput, DecimalInput } from '../../RegionInputs';

// The fields common to every ledger entry, plus the one that is only asked for
// a payment.

export default function TransactionForm({
  kind, form, set, students,
  amountError = null, setAmount = null, amountStep = '0.01',
}) {
  // `setAmount` is `set('amount', …)` with the currency's decimal places already
  // applied (#246) — it lives in AddTransactionDrawer.jsx for the same reason
  // `amountError` does, because that component has the currency and this one
  // does not. Defaulted so the field still works if a caller passes neither.
  const writeAmount = setAmount || ((v) => set('amount', v));
  const names = useNames();
  return (
    <div className={s.body}>
      {students.length ? (
        <Field label="Student" hint="Optional">
          <select
            className={s.input}
            value={form.studentId}
            onChange={(e) => set('studentId', e.target.value)}
          >
            <option value="">(Not Specified)</option>
            {students.map((st) => (
              <option key={st.id} value={st.id}>{names.student(st)}</option>
            ))}
          </select>
        </Field>
      ) : null}

      <div className={s.fieldNarrow}>
        <Field label="Date">
          <DateInput className={s.input}
            value={form.date} onChange={(e) => set('date', e.target.value)}
          />
        </Field>
      </div>

      <div className={s.fieldNarrow}>
        {/* `amountError` is computed in AddTransactionDrawer.jsx, which has the
            studio's currency (#164): a figure past MAX_MONEY_MINOR is refused
            here rather than reaching `appendEntry` as a bare permission-denied.

            The `step` is the currency's own minor unit rather than `0.01`
            (#246): in KWD a third decimal is legitimate, and in JPY there is no
            fractional part. */}
        <Field label="Amount" error={amountError}>
          <DecimalInput
            className={s.input} placeholder="0.00"
            value={form.amount} onChange={(e) => writeAmount(e.target.value)}
          />
        </Field>
      </div>

      <div className={s.field}>
        <Field label="Description" hint="This will appear on the invoice">
          <textarea
            rows={3} className={s.input}
            value={form.description} onChange={(e) => set('description', e.target.value)}
          />
        </Field>
      </div>

      {kind === 'payment' ? (
        <>
          <label className={s.checkRow}>
            <input
              type="checkbox" checked={form.emailReceipt}
              onChange={(e) => set('emailReceipt', e.target.checked)}
            />
            <span>Send an email receipt</span>
          </label>
        </>
      ) : null}
    </div>
  );
}
